const API_URL = process.env.REACT_APP_API_URL;


const handleFetch = async (url, method, headers, body = null) => {
  try {
    const response = await fetch(url, {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : null,
    });
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

const handleResponse = async (response) => {
  if (!response.ok) {
    return handleError({ message: 'Something went wrong. Please try again later.' });
  }
  return response.json();
};

const handleError = (error) => {
  return { error: error.message };
};

const Get = async (endpoint, headerValue = {}) => {
  const url = `${API_URL}${endpoint}`;
  const headers = {
    ...headerValue,
    ...(Object.keys(headerValue).length === 0 && { 'Content-Type': 'application/json' }),
  };
  return handleFetch(url, 'GET', headers);
};

const Post = async (endpoint, data, headerValue = {}) => {
  const url = `${API_URL}${endpoint}`;
  const headers = {
    ...headerValue,
    ...(Object.keys(headerValue).length === 0 && { 'Content-Type': 'application/json' }),
  };

  return handleFetch(url, 'POST', headers, data);
};

const PostForMultiPartFormData = async (endpoint, formData, headers = {}) => {
  const url = `${API_URL}${endpoint}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        ...headers, 
      },
      body: formData,
    });

    // Handle response
    return handleResponse(response);
  } catch (error) {
    return handleError(error);
  }
};

const HttpPost = async (endpoint, connectingUserId, token) => {
  try {
    const url = `${API_URL}${endpoint}`;
    const data = new URLSearchParams({ connecting_user_id: connectingUserId });

    const response = await fetch(url, {
      method: "POST",
      headers: {
        appid: "22",
        authorization: `Bearer ${token}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: data,
    });

    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
    }
    return await handleResponse(response); 
  } catch (error) {
    console.error("API Call Failed:", error);
    return { success: false, error: error.message };
  }
};


export { Get, Post,PostForMultiPartFormData,HttpPost };
